import type { ModalProps } from '@vtex/admin-ui'

export enum DuplicateCheckbox {
  GENERAL = 'general',
  NAME_AND_DESCRIPTION = 'nameAndDescription',
  DATES_AND_RECURRENCE = 'datesAndRecurrence',
  COMMERCIAL_POLICIES = 'commercialPolicies',
  SELLERS = 'sellers',
  ITEMS_AND_BENEFITS = 'itemsAndBenefits',
  CONDITIONS = 'conditions',
  RESTRICTIONS = 'restrictions',
  ACCUMULATION = 'accumulation',
  STOREFRONT = 'storefront',
}

export type DuplicateModalProps = ModalProps & {
  onConfirm: (selectedSections: DuplicateSections) => void
}

export type DuplicateForm = {
  [DuplicateCheckbox.NAME_AND_DESCRIPTION]: boolean
  [DuplicateCheckbox.DATES_AND_RECURRENCE]: boolean
  [DuplicateCheckbox.COMMERCIAL_POLICIES]: boolean
  [DuplicateCheckbox.SELLERS]: boolean
  [DuplicateCheckbox.ITEMS_AND_BENEFITS]: boolean
  [DuplicateCheckbox.CONDITIONS]: boolean
  [DuplicateCheckbox.RESTRICTIONS]: boolean
  [DuplicateCheckbox.ACCUMULATION]: boolean
  [DuplicateCheckbox.STOREFRONT]: boolean
}

export type DuplicateSections = {
  [DuplicateCheckbox.GENERAL]: {
    selected: boolean
    [DuplicateCheckbox.NAME_AND_DESCRIPTION]: boolean
    [DuplicateCheckbox.DATES_AND_RECURRENCE]: boolean
  }
  [DuplicateCheckbox.COMMERCIAL_POLICIES]: boolean
  [DuplicateCheckbox.SELLERS]: boolean
  [DuplicateCheckbox.ITEMS_AND_BENEFITS]: boolean
  [DuplicateCheckbox.CONDITIONS]: boolean
  [DuplicateCheckbox.RESTRICTIONS]: boolean
  [DuplicateCheckbox.ACCUMULATION]: boolean
  [DuplicateCheckbox.STOREFRONT]: boolean
}

export type RegularCheckboxProps = {
  checkboxType: DuplicateCheckbox
  messageKey: string
  drawerForm: any
  onCheckboxChange: (checkboxName: DuplicateCheckbox, newValue: boolean) => void
  $t: (message: any) => string
  isChecked: boolean
}
